<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="a"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $tc('messages.domains', 2),
                        href: meta.links.category_index,
                    },
                    {
                        name: $t('messages.syllabus'),
                        href: null,
                    },
                    {
                        name: $t('messages.import'),
                        href: null,
                    },
                ]"
            />
        </template>

        <Tabs :default-index="stages.findIndex((s) => s.first)">
            <Tab :title="stage.display_name" v-for="stage in stages" :key="stage.id">
                <Tabs>
                    <Tab
                        :title="category.name"
                        :selected="categoryIndex === 0"
                        v-for="(category, categoryIndex) in stage.categories"
                        :key="category.id"
                    >
                        <h6 class="text-xl font-semibold text-gray-900">
                            {{ category.name }}
                        </h6>
                        <template v-for="dimension in category.dimensions" :key="dimension.id">
                            <details class="w-full pt-5">
                                <summary>
                                    {{ dimension.abbreviation }} -
                                    {{ dimension.title }}
                                </summary>
                                <p class="whitespace-pre-line">{{ dimension.description || '-' }}</p>
                            </details>
                            <ul>
                                <li
                                    class="ml-5 list-disc"
                                    v-for="competence in dimension.competences"
                                    :key="competence.id"
                                >
                                    {{ competence.abbreviation }} -
                                    {{ competence.description }}
                                </li>
                            </ul>
                        </template>
                    </Tab>
                </Tabs>
            </Tab>
        </Tabs>

        <div class="flex justify-end mt-5">
            <ConfirmActionButton
                :href="meta.links.store"
                :confirm-text="$t('messages.import')"
                :title="$t('messages.import')"
                desired-action
                :button-text="$t('messages.import')"
            >
                <div v-for="stage in meta.info.summary" :key="stage.id" class="mt-3">
                    <div>
                        <b>{{ stage.display_name }}</b>
                        <ul>
                            <li>{{ stage.categories_count }} {{ $tc('messages.domains', stage.categories_count) }}</li>
                            <li>{{ stage.subjects_count }} {{ $tc('messages.subject', stage.subjects_count) }}</li>
                            <li>
                                {{ stage.dimensions_count }} {{ $tc('messages.dimensions', stage.dimensions_count) }}
                            </li>
                        </ul>
                    </div>
                </div>
            </ConfirmActionButton>
        </div>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import Tabs from '@/components/Tabs.vue';
import Tab from '@/components/Tab.vue';
import ConfirmActionButton from '@/components/ConfirmActionButton.vue';

export default {
    components: {
        ConfirmActionButton,
        PanelPage,
        Tabs,
        Tab,
    },
    layout: Layout,
    name: 'Index',
    props: ['meta', 'stages', 'filters', 'options'],
    data() {
        return {};
    },
    methods: {},
};
</script>
